import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@/shared/components/ui/Icon';
import { useI18n } from '@/shared/i18n/useT';
import { folderPath, type FoldersPathStep } from '@/shared/folders';

interface Props {
  /** Root first, current folder last. Empty at the root of the folders. */
  path: readonly FoldersPathStep[];
}

export function Breadcrumb({ path }: Props) {
  const { t } = useI18n();

  return (
    <nav aria-label={t('folders.title')} className="flex min-w-0 items-center gap-1 text-sm">
      <Link
        to={folderPath(null)}
        className="tap-target flex items-center gap-2 rounded-token px-2 text-muted hover:text-fg"
      >
        <Icon name="folder" className="h-4 w-4 shrink-0" />
        <span className="truncate">{t('folders.root')}</span>
      </Link>

      {path.map((step, index) => {
        const isLast = index === path.length - 1;
        return (
          <Fragment key={step.id}>
            <Icon name="chevronRight" className="h-4 w-4 shrink-0 text-muted" />
            {isLast ? (
              // The current folder is not a link: navigating to where you are is
              // a dead control, and `aria-current` says so out loud.
              <span aria-current="page" className="truncate px-2 font-medium text-fg">
                {step.name}
              </span>
            ) : (
              <Link
                to={folderPath(step.id)}
                className="tap-target truncate rounded-token px-2 text-muted hover:text-fg"
              >
                {step.name}
              </Link>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}






